export class RestoreTemplateFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "FreeTextFilters",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "RestoreTemplateResourceTypeFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreTemplateFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
